import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CabsandPrestartJobcardPage } from './cabsand-prestart-jobcard';

@NgModule({
  declarations: [
    CabsandPrestartJobcardPage,
  ],
  imports: [
    IonicPageModule.forChild(CabsandPrestartJobcardPage),
  ],
})
export class CabsandPrestartJobcardPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cabsand-prestart-jobcard/cabsand-prestart-jobcard.module.ts